import { useEffect } from "react";

/**
 * Hook that handles asynchronous log line navigation.
 * Waits for log line elements to appear in the DOM and scrolls to them.
 */
export function useLogLineNavigation({ group, line }) {
  useEffect(() => {
    if (!Features.RefactorLogScrollBehaviour || (!line && !group)) {
      return;
    }

    const targetLineNumber = line || group;
    const selector = `[data-line-number="${targetLineNumber}"]`;

    const waitForElementAndScroll = () => {
      // Check if element already exists
      const existingElement = document.querySelector(selector);
      if (existingElement) {
        existingElement.scrollIntoView({ behavior: "smooth" });
        return;
      }

      // Set up MutationObserver to watch for the element
      const observer = new MutationObserver(() => {
        const foundElement = document.querySelector(selector);
        if (foundElement) {
          observer.disconnect();
          foundElement.scrollIntoView({ behavior: "smooth" });
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });

      // Just in case the content doesn't load we'll clean up the observer after a reasonable wait time
      const timeoutId = setTimeout(() => {
        observer.disconnect();
      }, 5000);

      return () => {
        observer.disconnect();
        clearTimeout(timeoutId);
      };
    };

    const cleanup = waitForElementAndScroll();
    return cleanup;
  }, [group, line]);
}
